var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMinified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.998 39.997a5 5 0 005.002-5A5 5 0 0034.998 30a5 5 0 00-5.001 4.999 5 5 0 005.001 4.999z",
    fill: "#00F0FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.998.003H5A5 5 0 000 5.002 5 5 0 005 10h17.922L1.465 31.467a4.996 4.996 0 00-1.083 5.447A5.004 5.004 0 005.004 40h18.987a5.001 5.001 0 005.002-4.999c0-2.76-2.24-4.999-5.002-4.999h-6.918L38.534 8.536A5 5 0 0034.994 0l.004.003z",
    fill: "#fff"
  })));
}
export default SvgLogoMinified;